import * as React from 'react';

import {ButtonCard} from '../card/button-card';

import styles from './two-line-button-card.module.css';

type Props = {
    children: React.ReactNode;
    onClick?: () => void;
    isSelected?: boolean;
    isDisabled?: boolean;
};

TwoLineButtonCard.defaultProps = {
    as: 'button',
};

export function TwoLineButtonCard(props: Props) {
    const buttonCardStyle = {
        width: '100%',
        height: 'auto',
    } as const;

    return (
        <ButtonCard
            // @ts-expect-error
            style={buttonCardStyle}
            onClick={props.onClick}
            isSelected={Boolean(props.isSelected)}
            isDisabled={Boolean(props.isDisabled)}
        >
            <div className={styles['two-line-button-card']}>{props.children}</div>
        </ButtonCard>
    );
}
